import { Component } from '@angular/core'
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import {
  FormlyFieldConfig,
  FormlyFormOptions,
  FormlyModule,
} from '@ngx-formly/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'

import { ButtonComponent } from '../../components/button/button.component'
import { CognitoService } from '../../services/cognito.service'

export type ChangePasswordFormModel = {
  passwordValidation: string
  confirmPassword: string
}

@Component({
  selector: 'app-change-password',
  imports: [
    ButtonComponent,
    FormlyModule,
    ReactiveFormsModule,
    SvgIconComponent,
    TranslatePipe,
  ],
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent {
  public loading: boolean = false
  public errorText = ''

  public form = new FormGroup({})
  public options: FormlyFormOptions = {}
  public model: ChangePasswordFormModel = {
    passwordValidation: '',
    confirmPassword: '',
  }
  public confirmResetFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'flex flex-col gap-8',
      fieldGroup: [
        {
          type: '#passwordValidation',
          props: {
            label: 'pages.forceChangePassword.newPassword.label',
          },
        },
        {
          type: '#password',
          key: 'confirmPassword',
          props: {
            label: 'pages.forceChangePassword.confirmPassword.label',
            recoveryStartSuccessful: false,
          },
          validators: {
            fieldMatch: {
              expression: (
                control: AbstractControl,
                field: FormlyFieldConfig
              ): boolean => {
                const newPassword = field.parent?.model['passwordValidation']
                const confirmPassword = control.value
                return newPassword === confirmPassword
              },
            },
          },
        },
      ],
    },
  ]

  public constructor(
    private readonly cognitoService: CognitoService,
    private readonly translate: TranslateService
  ) {}

  public async submit(): Promise<void> {
    this.loading = true
    this.errorText = ''

    const { passwordValidation } = this.model

    this.cognitoService
      .confirmNewPassword(passwordValidation)
      .catch(() => {
        this.errorText = this.translate.instant('validation.genericError')
      })
      .finally(() => {
        this.loading = false
      })
  }
}
